module.exports = __webpack_public_path__ + "static/media/logowanie-mob-swieta.9a1ca19b.png";